/**
 * Display name for an order's related profile (seller / buyer).
 *
 * Ported from PopshopRN's `screenNameOrNicknameWithInitial`
 * (`src/functions/models/profiles.ts`): prefer the storefront name, then the
 * username (ignoring the synthetic `psluser_` handles), then "First L.", then
 * the first name, finally a generic fallback.
 */
export function nicknameWithInitial(p?: {
  storeFrontName?: string | null;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}): string {
  if (!p) return 'User';

  if (p.storeFrontName) return p.storeFrontName;

  if (p.username && !p.username.startsWith('psluser_')) {
    return p.username;
  }

  if (p.firstName && p.lastName?.[0]) {
    return `${p.firstName} ${p.lastName[0].toUpperCase()}.`;
  }

  if (p.firstName) return p.firstName;

  return 'User';
}
